<div class="modal-header panel-heading">
    <h2 class="modal-title">{{ "itemNumbers.createNewTitle" | translate }}</h2>
    <button type="button" class="close" (click)="onClose()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    @if(ItemNumberForm) {
    <form [formGroup]="ItemNumberForm">
        <div class="form-group mt-lg px-2">
            <div class="row">
                <div class="col-12 mt-3">
                    <div class="form-label">
                        {{ "itemNumbers.form.title" | translate }}
                    </div>
                    <input type="text" class="form-control" formControlName="title">
                </div>
                <div class="col-12 mt-3">
                    <div class="form-label">
                        {{ "itemNumbers.form.description" | translate }}
                    </div>
                    <textarea class="form-control" rows="3" formControlName="description"></textarea>
                </div>
                <div class="col-6 mt-3">
                    <div class="form-label">
                        {{ "itemNumbers.form.hours" | translate }}
                    </div>
                    <input type="text" class="form-control" formControlName="hours">
                </div>
            </div>
        </div>
    </form>
    }
</div>
<div class="item-number-modal-footer">
    <button class="btn btn-primary ml-3" (click)="onSave()">
        {{ "labels.save" | translate }}
    </button>
    <button class="btn btn-danger ml-3" (click)="onClose()">
        {{ "labels.cancel" | translate }}
    </button>
</div>
